/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CoverplacementsQueryResponse } from '../../types/GetV1Coverplacements.ts'

export const getV1CoverplacementsQueryKey = () => [{ url: '/v1/CoverPlacements' }] as const

export type GetV1CoverplacementsQueryKey = ReturnType<typeof getV1CoverplacementsQueryKey>

/**
 * {@link /v1/CoverPlacements}
 */
export async function getV1Coverplacements(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1CoverplacementsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/CoverPlacements`, ...requestConfig })
    return res
}

export function getV1CoverplacementsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CoverplacementsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CoverplacementsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CoverplacementsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Coverplacements(config)
        },
    })
}

/**
 * {@link /v1/CoverPlacements}
 */
export function useGetV1Coverplacements<
    TData = ResponseConfig<GetV1CoverplacementsQueryResponse>,
    TQueryData = ResponseConfig<GetV1CoverplacementsQueryResponse>,
    TQueryKey extends QueryKey = GetV1CoverplacementsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CoverplacementsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CoverplacementsQueryKey()

    const query = useQuery(
        {
            ...getV1CoverplacementsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
